import Vapi from 'vuex-rest-api';

const fetcherAdminJobItem = new Vapi({
  state: {
    fetcherAdminJobItem: {
      id: 0,
    },
  },
})
  .get({
    action: 'getFetcherAdminJobItem',
    property: 'fetcherAdminJobItem',
    path: ({ jiid }) => `/api/fetcher/admin/jobItems/${jiid}`,
  })
  .getStore();

export default fetcherAdminJobItem;
